module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-192x192-a113433e3a44a36aafbbd067e989f10a.png";